import React from "react";
import { Search } from "lucide-react";
import { Input } from "../ui/input2";

interface SunbedActionToolbarProps {
  totalItems: number;
  showingStart: number;
  showingEnd: number;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  children?: React.ReactNode;
}

export const SunbedActionToolbar: React.FC<SunbedActionToolbarProps> = ({
  totalItems,
  showingStart,
  showingEnd,
  searchTerm,
  onSearchChange,
  searchPlaceholder = "Search...",
  children,
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 flex-shrink-0">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-[#885ABB] bg-[#F3E8FF] px-4 py-1.5 rounded-full border border-[#E9D5FF]">
          Total {totalItems} | Showing {showingStart}-{showingEnd}
        </span>
        {children}
      </div>

      <div className="relative w-full sm:w-72">
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 z-10">
          <Search size={16} />
        </div>
        <Input
          type="text"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 bg-white border-gray-200 focus:border-[#885ABB] focus:ring-[#885ABB]"
        />
      </div>
    </div>
  );
};
